import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { SetArrayDataCheckBoks } from "../../../Redux/Reducers/Shared/CheckBox";
import Swal from "sweetalert2";
import { setRefreshTable } from "../../../Redux/Reducers/Shared/VariousVariables";
import SharedDiv from "../../../Components/SharedDiv/SharedDiv";
import TransferBetweenEvaluatorDropDowns from "./TransferBetweenEvaluatorDropDowns";
import ButtonAHSF from "../../../Components/ButtonAHSF";
import TransferBetweenEvaluatorTable from "./TransferBetweenEvaluatorTable";
import {
  UpdateAssigingUser,
  UpdateAssigingUserNew,
} from "../../../Redux/Reducers/Manager/EvaluatorInfo";

function TransferBetweenEvaluators() {
  const arrayDataCheckBoks = useSelector(
    (state) => state.arrayDataCheckBoks.arrayDataCheckBoks["SubtasksList"]
  );

  console.log(arrayDataCheckBoks, "arrayDataCheckBoks");

  const [roundActive, setRoundActive] = useState(null);
  const [DropDownFrom, setDropDownFrom] = useState(null);
  const [DropDownTo, setDropDownTo] = useState(null);
  const [DropDownSubject, setDropDownSubject] = useState(null);

  const [fields, setFields] = useState(null);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  console.log(DropDownFrom, "dot");

  arrayDataCheckBoks?.map((item) => item.subTaskId);
  // arrayDataCheckBoks["evaluatorList"]?.map((item) => item.subTaskId);

  const ChangeEvaluator = async () => {
    dispatch(SetArrayDataCheckBoks());
    const missingFields = [];

    if (!roundActive) missingFields.push("الدورة");
    if (!fields) missingFields.push("الحقل");
    if (!DropDownSubject) missingFields.push("الموضوع");
    if (!DropDownFrom) missingFields.push("المحكم الحالي");
    if (!DropDownTo) missingFields.push("المحكم الجديد");
    if (!arrayDataCheckBoks || arrayDataCheckBoks.length === 0)
      missingFields.push("المهام المحددة");

    if (missingFields.length > 0) {
      Swal.fire({
        icon: "warning",
        title: "الرجاء تعبئة الحقول التالية",
        html: `
        <div style="text-align: right; direction: rtl; font-size: 16px;">
          <ul style="list-style-type: none; padding: 0;">
            ${missingFields
              .map(
                (field) =>
                  `<li style="margin-bottom: 8px;">🔸 <strong>${field}</strong></li>`
              )
              .join("")}
          </ul>
        </div>
      `,
        confirmButtonText: "حسناً",
        customClass: { popup: "swal2-border-radius" },
      });
      return;
    }

    const result = await Swal.fire({
      title: "هل انت متأكد من التحويل بين المحكمين؟",
      icon: "warning",
      confirmButtonText: "تأكيد",
      cancelButtonText: "إلغاء",
      showCancelButton: true,
      showCloseButton: true,
    });

    if (result.isConfirmed) {
      try {
        const UpdateAssigin = await dispatch(
          UpdateAssigingUser({
            subTasksIdsList: arrayDataCheckBoks.map((item) => item.subTaskId),
            userToId: DropDownTo,
          })
        ).unwrap();
       
        
        if (UpdateAssigin) {
          Swal.fire({
            position: "center",
            icon: "success",
            title: "تم التحويل بنجاح",
            showConfirmButton: false,
            timer: 1500,
          });

          dispatch(setRefreshTable({ tableId: "EvaluatorTransfer" }));
          dispatch(SetArrayDataCheckBoks());
        }
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "حدث خطأ أثناء التحويل",
          text: error.message || "يرجى المحاولة لاحقًا",
        });
      }
    }
  };
  console.log(arrayDataCheckBoks, "arrayDataCheckBoksll");

  useEffect(() => {
    dispatch(SetArrayDataCheckBoks());
  }, []);
  const ChangeEvaluatorNew = async () => {
    const missingFields = [];

    if (!roundActive) missingFields.push("الدورة");
    if (!fields) missingFields.push("الحقل");
    if (!DropDownSubject) missingFields.push("الموضوع");
    if (!DropDownFrom) missingFields.push("المحكم الحالي");
    if (!DropDownTo) missingFields.push("المحكم الجديد");
    if (!arrayDataCheckBoks || arrayDataCheckBoks.length === 0)
      missingFields.push("المهام المحددة");

    if (missingFields.length > 0) {
      Swal.fire({
        icon: "warning",
        title: "الرجاء تعبئة الحقول التالية",
        html: `
        <div style="text-align: right; direction: rtl; font-size: 16px;">
          <ul style="list-style-type: none; padding: 0;">
            ${missingFields
              .map(
                (field) =>
                  `<li style="margin-bottom: 8px;">🔸 <strong>${field}</strong></li>`
              )
              .join("")}
          </ul>
        </div>
      `,
        confirmButtonText: "حسناً",
      });
      return;
    }

    const result = await Swal.fire({
      title: "هل أنت متأكد من تحويل الطلبات؟",
      icon: "warning",
      confirmButtonText: "تأكيد",
      cancelButtonText: "إلغاء",
      showCancelButton: true,
      showCloseButton: true,
    });

    if (!result.isConfirmed) return;

    try {
      const response = await dispatch(
        UpdateAssigingUserNew({
          subTasksIdsList: arrayDataCheckBoks.map((item) => item.subTaskId),
          userToId: DropDownTo,
        })
      ).unwrap();
      if (response) {
        Swal.fire({
          position: "center",
          icon: "success",
          title: response.message || "تم التحويل بنجاح",
          showConfirmButton: false,
          timer: 1500,
        });

        dispatch(setRefreshTable({ tableId: "EvaluatorTransfer" }));
        dispatch(SetArrayDataCheckBoks());
      }
    } catch (errorMessage) {
      Swal.fire({
        icon: "warning",
        title: "تنبيه",
        text: errorMessage || "حدث خطأ أثناء التحويل",
        confirmButtonText: "حسناً",
      });
    }
  };
console.log(arrayDataCheckBoks, "arrayDataCheckBoks");

  return (
    <>
      <SharedDiv
        showTitle={true}
        titleNameAR="معلومات الطلب"
        child={[
          <>
            <TransferBetweenEvaluatorDropDowns
              setRoundActive={setRoundActive}
              setFields={setFields}
              setSubject={setDropDownSubject}
              setDropDownFrom={setDropDownFrom}
              DropDownFrom={DropDownFrom}
              DropDownTo={DropDownTo}
              setDropDownTo={setDropDownTo}
            />
            <TransferBetweenEvaluatorTable
              fields={fields}
              subject={DropDownSubject}
              DropDownFrom={DropDownFrom}
            />
          </>,
        ]}
      />
      <div className="containerButtonMAin">
        <div>
          <ButtonAHSF
            fieldsName="WithdrawandtransferRequest"
            lang={"ar"}
            title={"سحب الطلبات وتحويلها"}
            text={"سحب الطلبات وتحويلها"}
            onClick={() => {
              ChangeEvaluator();
            }}
            disabled={false}
            show={true}
          />
        </div>
        <div>
          <ButtonAHSF
            fieldsName="TransferNewRequest"
            lang={"ar"}
            title={"تحويل طلبات جديدة"}
            text={"تحويل طلبات جديدة"}
            onClick={() => {
              ChangeEvaluatorNew();
            }}
            disabled={false}
            show={true}
          />
        </div>
      </div>
    </>
  );
}

export default TransferBetweenEvaluators;
